import React from 'react';
import PropTypes from 'prop-types';

import Iconify from "../../ui/iconify/Iconify";

const TooltipComponent = ({ iconName, message }) => {
    if (!iconName || !message) return null;  // Only render if both iconName and message are provided

    return (
        <div className="icon-fix">
            <div className="input-icon">
                <Iconify icon={iconName} className="button-icon" />
                <span className="tooltip-text">
                    {message}
                </span>
            </div>
        </div>
    );
};

TooltipComponent.propTypes = {
    iconName: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
};

export default TooltipComponent;
